var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    id: "Filled_Outline",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14,17c-2.76,0-5-2.24-5-5s2.24-5,5-5c0-3.31,2.69-6,6-6c2.63,0,4.86,1.69,5.67,4.04    C28.67,5.37,31,7.92,31,11c0,3.31-2.69,6-6,6H14z",
    fill: "#7CA7C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,17c-2.21,0-4-1.79-4-4s1.79-4,4-4c0-3.31,2.69-6,6-6c2.63,0,4.87,1.7,5.67,4.05    C19.11,7.37,21,9.47,21,12c0,2.76-2.24,5-5,5H5z",
    fill: "#7CA7C6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28,30c-0.562,0-0.803-0.217-1.293-0.707C26.162,28.747,25.414,28,24,28s-2.162,0.747-2.707,1.293    C20.803,29.783,20.562,30,20,30s-0.803-0.217-1.293-0.707C18.162,28.747,17.414,28,16,28s-2.162,0.747-2.707,1.293    C12.803,29.783,12.562,30,12,30s-0.803-0.217-1.293-0.707C10.162,28.747,9.414,28,8,28s-2.162,0.747-2.707,1.293    C4.803,29.783,4.562,30,4,30c-0.811,0-1.44-0.521-2.048-1.025C1.373,28.496,0.774,28,0,28l-0.041,1.996    c0.133,0.036,0.484,0.327,0.716,0.52C1.432,31.142,2.468,32,4,32c1.414,0,2.162-0.747,2.707-1.293C7.197,30.217,7.438,30,8,30    s0.803,0.217,1.293,0.707C9.838,31.253,10.586,32,12,32s2.162-0.747,2.707-1.293C15.197,30.217,15.438,30,16,30    s0.803,0.217,1.293,0.707C17.838,31.253,18.586,32,20,32s2.162-0.747,2.707-1.293C23.197,30.217,23.438,30,24,30    s0.803,0.217,1.293,0.707C25.838,31.253,26.586,32,28,32c1.532,0,2.568-0.858,3.324-1.484C31.557,30.323,31.907,30.032,32,30v-2    c-0.774,0-1.373,0.496-1.952,0.975C29.44,29.479,28.811,30,28,30z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -15.3418 16.9663)",
    width: 4.083,
    x: 4.979,
    y: 20.768
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -20.3834 16.9663)",
    width: 2,
    x: 3.5,
    y: 25.134
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -12.8414 21.2966)",
    width: 4.083,
    x: 9.979,
    y: 20.768
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -17.883 21.2967)",
    width: 2,
    x: 8.5,
    y: 25.134
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -10.341 25.627)",
    width: 4.083,
    x: 14.979,
    y: 20.768
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -15.3826 25.627)",
    width: 2,
    x: 13.5,
    y: 25.134
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -7.8406 29.9573)",
    width: 4.083,
    x: 19.979,
    y: 20.768
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -12.8822 29.9574)",
    width: 2,
    x: 18.5,
    y: 25.134
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -5.3402 34.2877)",
    width: 4.083,
    x: 24.979,
    y: 20.768
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -10.3818 34.2878)",
    width: 2,
    x: 23.5,
    y: 25.134
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    width: 2,
    x: 9,
    y: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,18h2v-2H5c-1.654,0-3-1.346-3-3s1.346-3,3-3c0.552,0,1-0.447,1-1c0-2.757,2.243-5,5-5    c2.139,0,4.037,1.355,4.723,3.372c0.123,0.36,0.439,0.62,0.816,0.669C18.512,8.3,20,10.002,20,12c0,2.206-1.794,4-4,4h-2h-1v2h1h2    h9c3.86,0,7-3.141,7-7c0-3.366-2.373-6.214-5.611-6.86C25.272,1.641,22.777,0,20,0c-2.237,0-4.332,1.09-5.642,2.876    C13.349,2.323,12.206,2,11,2C7.449,2,4.507,4.658,4.059,8.089C1.75,8.53,0,10.564,0,13C0,15.757,2.243,18,5,18z M20,2    c2.132,0,4.03,1.353,4.725,3.366c0.126,0.365,0.452,0.626,0.836,0.668C28.091,6.312,30,8.447,30,11c0,2.757-2.243,5-5,5h-4.54    c0.954-1.063,1.54-2.462,1.54-4c0-2.793-1.939-5.2-4.601-5.832c-0.349-0.796-0.851-1.492-1.445-2.09C16.889,2.788,18.393,2,20,2z",
    fill: "#1A1A1A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.24cc83590be980bc81d6caffcc7df842.svg";
export { ForwardRef as ReactComponent };